import script from "./OrganizationReferralBuilder.vue?vue&type=script&lang=ts&setup=true"
export * from "./OrganizationReferralBuilder.vue?vue&type=script&lang=ts&setup=true"

import "./OrganizationReferralBuilder.vue?vue&type=style&index=0&id=03ebc076&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03ebc076"]])

export default __exports__